import React from 'react';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { FormItemType } from '@src/framework/workbench/drawer/constants';
import { BOLD_ICON, ITALIC_ICON, UNDERLINE_ICON } from '@src/framework/workbench/drawer/image';
import { COMMON_STYLE } from '@src/framework/workbench/drawer/common/config';
import { config as boldConfig } from '@src/framework/workbench/ui/bold/config';
import { config as italicConfig } from '@src/framework/workbench/ui/italic/config';
import { config as underlineConfig } from '@src/framework/workbench/ui/underline/config';
import Style from '@framework/workbench/drawer/ui/index.less';
import type { FormConfig } from '@tencent/wb-ext-form';

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.GLOBAL_FONT_STYLE_BOLD,
        options: {
            icon: <img src={BOLD_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: boldConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.GLOBAL_FONT_STYLE_ITALIC,
        options: {
            icon: <img src={ITALIC_ICON} alt={''} className={Style['btn-icon']}/>,
        },
        tooltip: italicConfig.tipMsg,
        preventFocus: true,
        style: COMMON_STYLE,
    },
];

export const FontStyleName = {
    Bold: 'bold',
    Italic: 'italic',
};
